import { render } from "./MenuForGroup.vue?vue&type=template&id=2b1e8077&scoped=true"
import script from "./MenuForGroup.vue?vue&type=script&lang=js"
export * from "./MenuForGroup.vue?vue&type=script&lang=js"

import "./MenuForGroup.vue?vue&type=style&index=0&id=2b1e8077&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1e8077"]])

export default __exports__